import { globalLogger } from '../../qaamgo/helper/global-logger';

function isGrecaptchaNotLoadedYet() {
    return (
        typeof grecaptcha === 'undefined' ||
        typeof grecaptcha.execute === 'undefined' ||
        typeof grecaptcha.getResponse === 'undefined' ||
        typeof grecaptcha.ready === 'undefined' ||
        typeof grecaptcha.render === 'undefined' ||
        typeof grecaptcha.reset === 'undefined'
    );
}

class CaptchaHelper {
    constructor() {
        this.callback = function () {};
        this.rendered = false;
        this.initialized = false;
    }

    /**
     * @param {Object} config
     * @param {function} config.callback
     * @param {string} config.sitekey
     */
    init(config) {
        this.callback = config.callback;

        if (this.initialized) {
            globalLogger.log('qgcaptcha - fail - already initialized');

            return;
        }

        this.sitekey = config.sitekey;

        this.initialized = true;

        this._renderCaptcha();
    }

    captcha() {
        if (!this.initialized) {
            globalLogger.log('qgcaptcha - fail - not initialized');

            return;
        }

        if (!this.rendered) {
            globalLogger.log('qgcaptcha - fail - not rendered');

            if (typeof this.callback === 'function') {
                // since captcha is not rendered yet we just try to make the callback
                // without the captcha
                this.callback();
            }

            return;
        }

        const _this = this;

        _this._startCaptcha(true);
    }

    _renderCaptcha() {
        const _this = this;

        // make sure grecaptcha is fully loaded
        if (isGrecaptchaNotLoadedYet()) {
            setTimeout(function () {
                _this._renderCaptcha();
            }, 500);

            return;
        }

        this.rendered = true;

        let captchaContainer = document.getElementById('recaptchaContainer');

        if (captchaContainer === null) {
            captchaContainer = document.createElement('div');

            // make sure the captcha box is visible and above other content
            captchaContainer.style = '';
            captchaContainer.id = 'recaptchaContainer';

            // prepend because google renders the challenge overlay (the thing where you have to click on bikes)
            // relative to this element's position for some bizarre reason,
            // i.e. if the captcha container is at the very end of the document body,
            // the challenge overlay will end up there as well
            document.body.prepend(captchaContainer);
        }

        grecaptcha.render('recaptchaContainer', {
            sitekey: this.sitekey,
            size: 'invisible',
            callback: this.callback,
        });
    }

    _checkCaptchaNeeded() {
        var deferred = $.Deferred();
        var apiUrl = sat.apiUrl;

        $.ajax({
            url: apiUrl + '/api/captcha',
            xhrFields: {
                withCredentials: true,
            },
        })
            .done(function (data) {
                deferred.resolve(data.required);
            })
            .fail(function () {
                deferred.reject();
            });

        return deferred;
    }

    _startCaptcha(performCaptcha) {
        if (performCaptcha === false) {
            this.callback();

            return;
        }

        grecaptcha.execute();
    }
}

export { CaptchaHelper };
